<template>
  <div class="mc-wrapper">
    <div class="mc-container">
      <div class="mc-orders">
        <section class="mc-orders__tabs mc-tabs mc-tabs--fr">
          <div class="mc-tabs__button-wrapper">
            <ul class="mc-tabs__list">
              <li class="mc-tabs__item" :class="tabShow==1?'isActive':''" @click="tabShow=1" ref="tab1">
                <button class="mc-tabs__button js-button-tab" data-name="content1" type="button">
                  Активные
                </button>
              </li>
              <li class="mc-tabs__item" :class="tabShow==2?'isActive':''" @click="tabShow=2" ref="tab2">
                <button class="mc-tabs__button js-button-tab" data-name="content2" type="button">
                  Завершенные
                </button>
              </li>
              <li class="mc-tabs__glide" :style="tabGlide"></li>
            </ul>
          </div>
          <div v-if="ordersLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
          <div v-if="ordersError" class="mc-error">{{ ordersError }}</div>
          <div v-if="ordersLoaded" class="mc-tabs__body-wrapper">
            <div class="mc-tabs__body" :class="tabShow==1?'isActive':''" id="content1">
              <ul class="mc-orders__list">
                <li v-for="item in orders" class="mc-orders__item mc-orders-item">
                  <div class="mc-orders-item__top">
                                            <span class="mc-orders-item__status">
                                                {{ item.status }}
                                            </span>
                    <div class="mc-orders-item__title">
                      Заказ №{{ item.number }} от {{ item.date_create }}
                    </div>
                  </div>

                      <swiper
                          wrapperTag="ul"
                          :modules="modules"
                          :pagination="false"
                          slides-per-view="auto"
                          :space-between="10"
                          :freeMode="true"
                          class="mc-orders-item__slider swiper-free-mode"
                          wrapperClass="mc-orders-item__slider-list">
                        <swiper-slide v-for="product in item.items" class="mc-orders-item__slider-item" tag="li">
                        <router-link :to="product.url" class="mc-orders-item__product-wrapper">
                          <img class="mc-orders-item__product-image" :src="product.picture" width="60" height="100" alt="">
                        </router-link>
                        </swiper-slide>
                      </swiper>
                  <div class="mc-orders-item__bottom">
                    <div class="mc-orders-item__bottom-left">
                      {{ item.sum }} ₽
                    </div>
                    <div class="mc-orders-item__bottom-right">
                      <router-link :to="'/order/'+item.id+'/'" class="mc-orders-item__link">
                        Подробнее
                      </router-link>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="mc-tabs__body" :class="tabShow==2?'isActive':''" id="content2">
              <ul class="mc-orders__list">
                <li v-for="item in orders" class="mc-orders__item mc-orders-item">
                  <div class="mc-orders-item__top">
                                            <span class="mc-orders-item__status">
                                                {{ item.status }}
                                            </span>
                    <div class="mc-orders-item__title">
                      Заказ №{{ item.number }} от {{ item.date_create }}
                    </div>
                  </div>

                  <swiper
                      wrapperTag="ul"
                      :modules="modules"
                      :pagination="false"
                      slides-per-view="auto"
                      :space-between="10"
                      :freeMode="true"
                      class="mc-orders-item__slider swiper-free-mode"
                      wrapperClass="mc-orders-item__slider-list">
                    <swiper-slide v-for="product in item.items" class="mc-orders-item__slider-item" tag="li">
                      <router-link :to="product.url" class="mc-orders-item__product-wrapper">
                        <img class="mc-orders-item__product-image" :src="product.picture" width="60" height="100" alt="">
                      </router-link>
                    </swiper-slide>
                  </swiper>
                  <div class="mc-orders-item__bottom">
                    <div class="mc-orders-item__bottom-left">
                      {{ item.sum }} ₽
                    </div>
                    <div class="mc-orders-item__bottom-right">
                      <router-link :to="'/order/'+item.id+'/'" class="mc-orders-item__link">
                        Подробнее
                      </router-link>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';
import { Pagination, Navigation, Scrollbar } from 'swiper';
import {mapActions, mapGetters} from "vuex";
export default {
  data: () => ({
    modules: [Navigation, Scrollbar,Pagination],
    tabShow: 1,
    tabGlide: {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    },
    currentPage: 1,
    loadingMore: false,
  }),
  mounted() {
    setTimeout(() => {
      this.setTabActive(1);
    },500)
  },
  created() {
    this.fetchOrders({page:this.currentPage, finish: false});
    window.addEventListener('scroll', this.handleScroll);
  },
  components: {
    Swiper,
    SwiperSlide
  },
  watch: {
    tabShow(newValue, oldValue) {
      this.setTabActive(newValue);
      this.currentPage = 1;
      this.fetchOrders({page:1, finish: newValue==1?false:true});
    }
  },
  computed: {
    ...mapGetters([
      'orders',
      'ordersLoading',
      'ordersError',
      'ordersLoaded',
      'noMoreOrders',
    ]),
  },
  methods: {
    ...mapActions([
      'fetchOrders'
    ]),
    getPositionRelativeToParent(element) {
      var parent = element.parentElement;
      var parentRect = parent === null || parent === void 0 ? void 0 : parent.getBoundingClientRect();
      var elementRect = element.getBoundingClientRect();
      return {
        left: elementRect.left - parentRect.left,
        top: elementRect.top - parentRect.top
      };
    },
    setTabActive(newValue) {
      let tabItem = this.$refs['tab'+newValue];
      let relativePosition = this.getPositionRelativeToParent(tabItem);
      this.tabGlide.left = relativePosition.left + "px";
      this.tabGlide.top = relativePosition.top + "px";
      this.tabGlide.width = tabItem.offsetWidth + "px";
      this.tabGlide.height = tabItem.offsetHeight + "px";
    },
    handleScroll() {
      if (this.$route.name != 'orders') {
        window.removeEventListener('scroll', this.handleScroll);
      }
      // Calculate if we've reached the bottom of the page
      const bottomOfWindow = Math.max(
          window.scrollY,
          document.documentElement.scrollTop,
          document.body.scrollTop
      ) + window.innerHeight >= document.documentElement.scrollHeight - 200;

      // If we are at the bottom of the page and not currently loading more products
      if (bottomOfWindow && !this.loadingMore && this.ordersLoaded && !this.noMoreOrders) {
        this.loadMoreOrders();
      }
    },
    async loadMoreOrders() {
      // Set loading state
      if (this.loadingMore)
        return;
      this.loadingMore = true;

      // Get current page from store or local state
      const nextPage = this.currentPage + 1;
      await this.fetchOrders({ page:nextPage, finish: this.tabShow==1?false:true});
      this.loadingMore = false;
      this.currentPage++;
    },
  },
}
</script>

